module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_po_mob-4f64374aae27d4cf6b3a4faab67ffa2b.png";